import { database } from '../firebase'
import { ref as dbRef, get, query, orderByChild, equalTo, limitToFirst } from 'firebase/database'

export async function getUserRole(email) {
  if (!email) return 0

  try {
    const userQuery = query(
      dbRef(database, 'users'),
      orderByChild('email'),
      equalTo(email),
      limitToFirst(1)
    )
    const userSnapshot = await get(userQuery)
    let role = 0

    userSnapshot.forEach((childSnapshot) => {
      role = childSnapshot.val()?.role || 0
    })

    return role
  } catch (error) {
    console.error('Error getting user role:', error)
    return 0
  }
}
